import React from 'react';
import { Box } from '@osmosis/tailwind-ui/components/Box';

/**
 * Video placeholder.
 */
const VideoPlaceholder = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <Box
      className="absolute top-0 left-0 right-0 bottom-0 transition-all duration-300 ease-in-out rounded-[5px] h-auto bg-[rgba(0,78,150,0.8)] hover:bg-[rgba(0,78,150,0.9)]"
      style={style}
      data-testid="video-placeholder"
    />
  );
};

export default VideoPlaceholder;
